import { render } from "./UpdateCustomerPage.vue?vue&type=template&id=7d8a9935&scoped=true&ts=true"
import script from "./UpdateCustomerPage.vue?vue&type=script&lang=ts"
export * from "./UpdateCustomerPage.vue?vue&type=script&lang=ts"

import "./UpdateCustomerPage.vue?vue&type=style&index=0&id=7d8a9935&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/TTYT_NHS/ZaloOA/ZaloOA_TTYT_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8a9935"]])

export default __exports__